export const GOOGLE_CLIENT_ID =
  '358799734355-g5pgg2thq3pofdn90ei75hd5ojlejpf8.apps.googleusercontent.com';
